(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoLicService', ReporteEvaluativoLicService);

    ReporteEvaluativoLicService.$inject = ['$resource'];

    function ReporteEvaluativoLicService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/reporteLic:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteLic:id',
            	method:'PUT' 
            },
            'save': {
            	url:'apo/guardarreporteLic:id',
            	method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getRevision': {
            	url:'apo/revisionreporteLic:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'ver': {
            	url:'apo/verreporteLic:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();
